import { Switch } from "@/components/ui/switch";
import { Textarea, TextareaInput } from "@/components/ui/textarea";
import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Input, InputField } from "@/components/ui/input";
import React, { useEffect, useState } from 'react'
import { ModalWrapper } from "./ModalWrapper";

import AvatarEdit from '../../../../components/media/AvatarEdit';
import * as MediaSelector from '../../../../components/media/MediaSelector';

import { useSelector, useDispatch } from "react-redux";
import { requestModal } from '../../../../stores/mainSlice';
import { useNavigation } from "@react-navigation/native";
import { switchScreen } from '../../../../hooks/navigate';

import i18n from "i18n-js";
import * as assets_images from '../../../../assets/images';

export const ContactPreference = (modal) => {
  // const dispatch = useDispatch();
  // const navigation = useNavigation();

  const isWaiting = modal.option?.request?.isWaiting ?? false;
  const isAcknowledged = modal.option?.request?.isAcknowledged ?? false;
  const hasIssues = modal.option?.request?.issues ?? {};

  const contact_state = useSelector((state) => state.contacts.active) //
    .filter(_ => _.id === modal.option?.contact?.id)[0] ?? {};

  const [inputdContactImage, onInputdContactImage] = useState();
  const [inputdContactAlias, onInputdContactAlias] = useState();
  const [inputdPlanningAllowed, onInputdPlanningAllowed] = useState();

  if (isAcknowledged) {
    modal.onClose();
  }

  const all_workflows_lookup = useSelector((state) => state.workflows);

  useEffect(() => {
    if (modal.opened === undefined) {
      onInputdContactImage(undefined);
      onInputdContactAlias(undefined);
      onInputdPlanningAllowed(contact_state?.planningAllowed ?? undefined);
    }
  }, [modal.opened]);

  useEffect(() => {
    if (contact_state?.id) {
      // ? restore values for update
      onInputdContactImage(contact_state?.contactImage?.id ?? undefined);
      onInputdContactAlias(contact_state?.contactAlias ?? undefined);
      onInputdPlanningAllowed(contact_state?.planningAllowed ?? undefined);
    }
  }, [contact_state]);

  const onBack = () => {
    modal.onClose();
  }

  const onSubmit = () => {
    submitInputs({
      contact: {
        ...contact_state,

        contactImage: inputdContactImage && (inputdContactImage != contact_state?.contactImage?.id)
          ? { blob_uri: inputdContactImage }
          : undefined, // { id: contact_state?.contactImage?.id } - this is not the same as for channels
        contactAlias: inputdContactAlias,
        planningAllowed: inputdPlanningAllowed
      }
    });
  }

  const submitInputs = ({ contact }) => {
    const issues = {}, request = {
      isWaiting: false,
      isAcknowledged: false,
      issues: null
    };

    // ? values
    let contact_alias = contact.contactAlias?.trim() ?? undefined;
    const contact_planning_allowed = !!contact.planningAllowed;

    // ? validation
    if (!contact_alias || contact_alias.length <= 1) {
      // Clearing the alias can happen, but the input field always returns a string;
      contact_alias = undefined;
      // issues['contact.contactAlias'] = 'err:missingName';
    }

    if (Object.keys(issues).length) {
      request.issues = issues;

      modal.onUpdate({ request });
      return;
    };

    console.debug('[Modal]', 'submit', { request })

    // ? request
    request.isWaiting = true;

    const request_path = '/contact/' + contact.id;
    const request_method = 'PUT';


    modal.onUpdate({ request });
    modal.onRequest('UPDATE_CHANNEL_INLINE', request_path, {
      contactAlias: contact_alias,
      planningAllowed: contact_planning_allowed, // that's a Date by the api; this is a boolean

      workflows: contact.workflows?.map((local_workflow_id) => (all_workflows_lookup[local_workflow_id].workflowId))
      // addChannels: [], // channels to add
      // delChannels: []  // channels to remove
    }, request_method).then((data) => {
      // ---
      console.debug('[Modal]', 'onRequest.then', !!data.result, data?.result)
      // ---

      if (data.result && contact.contactImage?.blob_uri) {
        const upload_request_path = '/contact/' + data.result.id + '/image';

        modal.onUploadImageAsyncRequest('UPDATE_IMAGE_INLINE', upload_request_path, {
          uri: contact.contactImage.blob_uri,
          title: data.result.preferredName,
          description: data.result.alias
        }).then((image_data) => {
          // ---
          console.debug('[Modal]', 'onUploadImageAsyncRequest.then', !!image_data.result, image_data.result)
          // ---

          // FIXME(@Milo): Show toast if image upload failed.
        });
      }

      if (data.result) {
        // will not wait for image

        modal.onUpdate({
          request: {
            isAcknowledged: true,  // signal modal can close
            isWaiting: true, // keep locked
            issues: null,
          }
        });
      }

    })
  }

  const contact_alias = inputdContactAlias ?? contact_state?.toUser?.mail ?? '';
  const contact_image = inputdContactImage ?? contact_state?.toUser?.id ?? assets_images.placeholderImg;

  return (
    <ModalWrapper
      onClose={modal.onClose}
      onBack={onBack}
      onSubmit={onSubmit}

      isVisible={modal.isVisible}
      isWaiting={isWaiting}

      title={i18n.t('contact.update')}
      buttonBack={{ text: i18n.t('addContact.cancel') }}
      buttonSubmit={{ text: i18n.t('channel.continue') }}
    >
      <VStack>
        <AvatarEdit
          key={contact_image} uri={contact_image}
          selected={onInputdContactImage} sync={'/contact/media/' + contact_image}
          // isDisabled={isWaiting || !modal.isVisible}
          isEdit={!(isWaiting || !modal.isVisible)}
        />
      </VStack>
      <VStack>
        <Input
          variant="outline" size="md"
          isDisabled={isWaiting || !modal.isVisible}
          isInvalid={'contact.contactAlias' in hasIssues}
          isReadOnly={false}
        >
          <InputField
            // value={inputdContactAlias ?? ''}
            defaultValue={contact_alias ?? ''}
            onChangeText={onInputdContactAlias}
            placeholder={i18n.t('contact.alias')}
          />
        </Input>
        {/* {'contact.contactAlias' in hasIssues && (
          <Text mt='$2' fontSize='$xs' color='$error600'>{i18n.t('channel.missing')}</Text>
        )} */}
      </VStack>
      <VStack>
        <Input
          variant="outline" size="md"
          isDisabled={true}
          isInvalid={false}
          isReadOnly={true}
        >
          <InputField
            defaultValue={contact_state?.toUser?.preferredName ?? ''}
            placeholder={i18n.t('accountSettings.preferredName')}
          />
        </Input>
      </VStack>
      <VStack>
        <HStack space="md" className="h-8 items-center w-[100%]">
          {/* TODO(@Milo): add an actual label to the input*/}
          <Text size="md" className="flex-1">{i18n.t('contact.planAllowed')}</Text>
          <Switch
            onToggle={() => {
              onInputdPlanningAllowed(!inputdPlanningAllowed)
            }}
            value={inputdPlanningAllowed ?? false}
            defaultValue={inputdPlanningAllowed ?? false}
            isDisabled={isWaiting || !modal.isVisible}
          />
        </HStack>
      </VStack>
      <VStack>
        {'request-failed' in hasIssues && (
          <Text className="mt-2 text-xs text-error-600">{hasIssues['request-failed']}</Text>
        )}
      </VStack>
    </ModalWrapper>
  );
}
